<template>
  <WdsAlert icon warning>
    {{ $t('You will need to complete your bank details in order to create a bill.') }}
    <template #footer>
      <WdsButton :href="buttonUrl" warning-subtle sm>{{ $t('Edit Bank details') }}</WdsButton>
    </template>
  </WdsAlert>
</template>

<script setup>
import { computed } from 'vue'
import { WdsAlert, WdsButton } from '@worksome/wds-components'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const { $t } = useTranslation()

const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(namedRoutes.frontend.user.profile.edit, {
    redirect_uri: redirectUri,
  })
  return `${path}#bank-setup`
})
</script>
